import { Component, OnInit } from '@angular/core';
import { RouteService } from '../../../../../services/route.service';
import { RestService } from '../../../../../services/rest.service';
import { environment } from '../../../../../../environments/environment';
import { BookAdditional } from '../../../../../models/book-additional';
import { BookAdditionalFactory } from '../../../../../models/factories/book-additional-factory';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { Materials } from '../../../../../models/materials';
import { BookAdditionalsComponent } from './book-additionals/book-additionals.component';
import { BackgroundImageDirective } from '../../../../../directives/background-image.directive';

@Component({
    selector: 'app-materials-modal',
    templateUrl: './materials-modal.component.html',
    styleUrls: ['./materials-modal.component.scss'],
    imports: [
        BookAdditionalsComponent,
        BackgroundImageDirective
    ],
    standalone: true
})
export class MaterialsModalComponent implements OnInit {

    static MODAL_ID = Materials.MODAL_ID;
    usedMaterials: Array<BookAdditional>;

    constructor(public applicationStateService: ApplicationStateService,
                private routeService: RouteService,
                private restService: RestService) {
    }

    ngOnInit(): void {

        const route = this.routeService.getRelativeRoute(environment.endpointUrls.usedMaterials, {});
        const factory = new BookAdditionalFactory();

        this.restService.get(route).then((result: Array<any>) => {
            this.usedMaterials = [];
            result.forEach(ele => {
                this.usedMaterials.push(factory.buildFromObject(ele));
            });
        });
    }

    getId() {
        return MaterialsModalComponent.MODAL_ID;
    }
}
